@if (stats) {
  <section class="mini-vertical-stats outer_seo_page_component_container">
    <div class="width_wrapper inner_seo_page_component_container">
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-value">{{ stats.totalTasks }}+</div>
          <div class="stat-label">
            <p>
              {{
                'PAGES.VERTICAL.MINI_VERTICAL.STATS.TASKS_COMPLETED' | translate
              }}
            </p>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-value">{{ stats.averageOffersPerTask }}</div>
          <div class="stat-label">
            <p>
              {{
                'PAGES.VERTICAL.MINI_VERTICAL.STATS.AVERAGE_OFFERS' | translate
              }}
            </p>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-value">
            {{
              stats.averageOfferPrice
                | currency: currencyCode : 'symbol' : '1.0-0'
            }}
          </div>
          <div class="stat-label">
            <p>
              {{
                'PAGES.VERTICAL.MINI_VERTICAL.STATS.AVERAGE_PRICE' | translate
              }}
            </p>
          </div>
        </div>
      </div>

      <div class="stats-footer">
        {{ 'PAGES.VERTICAL.MINI_VERTICAL.STATS.FOOTER' | translate }}
      </div>
    </div>
  </section>
}
